import React from "react";
import { CategoryEntity, BaseEventEntity } from "../../src/entities";
import { serverSideFetch } from "../../src/serverSideFetch";
import { emUrl } from "../../src/util";
import { Startpage } from "../../src/Startpage";
import MyErrorPage from "../404";
import {
  myStaticMiddleWare,
  ServerSidePropsWithError,
} from "../../src/server/middleware";
import { GetStaticPaths, GetStaticProps } from "next";
import { withDefaultLayout } from "../../src/layout/layout";

type Props = ServerSidePropsWithError<{
  category: CategoryEntity;
  events: BaseEventEntity[];
}>;

export default withDefaultLayout(function Category(props: Props) {
  if ("error" in props) {
    return (
      <MyErrorPage
        statusCode={props.error.statusCode}
        title="Die gewünschte Veranstaltungskategorie wurde nicht gefunden"
      />
    );
  }
  return (
    <Startpage
      events={props.events}
      category={props.category}
      extraCategories={[]}
    />
  );
});

export const getStaticPaths: GetStaticPaths = async () => {
  return {
    paths: [],
    fallback: "blocking",
  };
};

export const getStaticProps: GetStaticProps = myStaticMiddleWare<Props>(
  async (ctx) => {
    const cid = ctx.routeParams.cid;
    if (Array.isArray(cid)) {
      return {
        notFound: true,
      };
    }

    const {
      data: { events, category },
      status,
    } = await serverSideFetch(
      ctx,
      emUrl("user", "main", { category: cid }, true)
    );

    if (status !== 200 || category === null) {
      return {
        notFound: true,
      };
    }

    return {
      props: {
        category,
        events,
      },
      revalidate: 3,
    };
  }
);
